import { Providers } from './components/Providers'

export const App = (): JSX.Element => {
  return (
    <div data-testid="app">
      <Providers />
    </div>
  )
}